import { Button } from '@/components/ui/button'
import { FloatingActionIslandContent } from '@/components/ui/FloatingActionIslandContent'

type NodeAgentSaveIslandProps = {
  show: boolean
  saving: boolean
  onSave: () => void
}

export function NodeAgentSaveIsland({
  show,
  saving,
  onSave,
}: NodeAgentSaveIslandProps) {
  return (
    <FloatingActionIslandContent
      show={show}
      componentId="node-agent-save"
      priority={20}
    >
      <div className="inline-flex w-full max-w-2xl">
        <div className="flex flex-grow items-center mr-4 space-x-2 text-sm text-gray-600 dark:text-muted-foreground whitespace-nowrap pointer-events-none">
          <span className="font-medium">Unsaved changes</span>
        </div>
        <div className="flex justify-end items-center space-x-2 pointer-events-auto">
          <Button onClick={onSave} disabled={saving} size="sm" variant="form">
            {saving ? 'Saving...' : 'Update agent'}
          </Button>
        </div>
      </div>
    </FloatingActionIslandContent>
  )
}
